interface Props {
  services: any[];
  onEdit: (service: any) => void;
  onDelete: (id: string) => void;
}

export function ServiceTable({ services, onEdit, onDelete }: Props) {
  return (
    <div className="card shadow-sm border-0">
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr className="small text-uppercase text-muted">
              <th>Service Name</th>
              <th>Type</th>
              <th>Default Price (₹)</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {services.map((service) => (
              <tr key={service.id}>
                <td className="fw-semibold">{service.name}</td>

                <td>{service.serviceType}</td>

                <td>₹{service.defaultPrice.toLocaleString()}</td>

                <td>
                  <button
                    className="btn btn-link text-danger p-0 me-3"
                    onClick={() => onEdit(service)}
                  >
                    Edit
                  </button>

                  <button
                    className="btn btn-link text-danger p-0"
                    onClick={() => onDelete(service)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}

            {services.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center py-4 text-muted">
                  No services added yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
